// extracted by mini-css-extract-plugin
export var wrapper = "Cta-module--wrapper--3ILrp";
export var fCol = "Cta-module--f-col--VzqDb";
export var header = "Cta-module--header--1lUvo";
export var desc = "Cta-module--desc--3f9Pa";
export var img = "Cta-module--img--2VXba";